import { render } from "./SelectedNumbersTariffs.vue?vue&type=template&id=cbbb098a&scoped=true"
import script from "./SelectedNumbersTariffs.vue?vue&type=script&lang=js"
export * from "./SelectedNumbersTariffs.vue?vue&type=script&lang=js"

import "./SelectedNumbersTariffs.vue?vue&type=style&index=0&id=cbbb098a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbbb098a"]])

export default __exports__